import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { ReactNode } from 'react'

interface ModalBodyProps {
    children: ReactNode
    gradientStyle?: BuildGradientStyle
}

export const BonusModalBody = ({ children, gradientStyle }: ModalBodyProps) => {
    return (
        <div style={gradientStyle} className="-m-px">
            {children}
        </div>
    )
}
